import { getAccessToken } from '../../services/authService';
export async function organisationRequest(settings) {
  const token = getAccessToken();
  if (!token) throw new Error('Please sign in again.');
  const response = await fetch(`${process.env.REACT_APP_DEV_API}/account/organisation`, {
    method: settings ? 'PUT' : 'GET',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    ...(settings ? { body: JSON.stringify(settings) } : {}),
  });
  const body = await response.json();
  if (!response.ok) throw new Error(body.message || 'Could not load organisation settings.');
  return body.organisation;
}